window.lang2 = 
{
  "general": {
    "meta": {
      "tags": "Taggato \"{{ tags }}\"",
      "page": "Pagina {{ page }}"
    },
    "404": {
      "title": "404 Pagina Non Trovata",
      "subtext_html": "La pagina richiesta non esiste",
      "click_here": "Clicca qui",
      "continue_shopping": "Per continuare con gli acquisti"
    },
    "breadcrumbs": {
      "home": "Home",
      "cart": "Carrello",
      "home_link_title": "Torna alla Home"
    },
    "newsletter_form": {
      "newsletter_email": "Tua-email@esempio.it",
      "submit": "Sottoscrivi",
      "newsletter_text": "inserisci il tuo indirizzo email"
    },
    "search": {
      "no_results_html": "La tua ricerca per \"{{ terms }}\" non ha prodotto risutati.",
      "results_for_html": "La tua ricerca per \"{{ terms }}\" ha prodotto i seguenti risutati:",
      "title": "Ricerca per prodotti sul nostro sito",
      "placeholder": "cerca",
      "submit": "Cerca"
    },
    "currency": {
      "change_text": "La valuta dello store è cambiata in"
    }
  },
  "blogs": {
    "article": {
      "author_on_date_html": "Postato il {{ date }} da {{ author }}",
      "older_post": "Post Vecchi",
      "newer_post": "Post Nuovi",
      "tags": "Tags",
      "comment_meta_html": "{{ author }} il {{ date }}",
      "read_more": "Leggi altro"
    },
    "comments": {
      "title": "Invia un commento",
      "name": "Il Tuo Nome",
      "email": "La tua Email",
      "message": "Commento",
      "post": " Posta commento",
      "moderated": "Attenzione! I commenti devono essere approvati prima di essere pubblicati",
      "success_moderated": "Il tuo commento è stato inviato con successo. Lo pubblicheremo non appena sarà controllato dal moderatore",
      "success": "Il tuo commento è stato inviato con successo! Grazie!",
      "note": "Tutti i commenti del blog vengono controllati prima della pubblicazione",
      "comments_with_count": {
        "one": "{{ count }} commento",
        "other": "{{ count }} commenti"
      }
    },
    "sidebar": {
      "recent_articles": "Articoli Recenti",
      "categories": "Categorie"
    }
  },
  "cart": {
    "general": {
      "title": "Il mio Carrello",
      "remove": "Rimuovi",
      "subtotal": "Subtotale",
      "shipping_at_checkout": "I costi di spedizione verranno calcolati alla cassa",
      "update": "Aggiorna Carrello",
      "checkout": "Cassa",
      "button_checkout": "Vai alla Cassa",
      "empty": "Il tuo carrello è vuoto",
      "continue_browsing_html": "Continua a cercare<a href=\"\/collections\/all\">quì<\/a>",
      "view_cart": "Oppure Vedi il Carrello",
      "close_cart": "Chiudi il Carrello",
      "shopping_cart": "Carrello",
      "label": "Note",
      "label_text": "Commenti aggiuntivi",
      "shipping_calculator_button": "Calcola i costi di spedizione",
      "shipping_calculator_calculating": "Calcolando...",
      "shipping_calculator_error_message": "Errore: Per cortesia controlla i dati di spedizione immessi",
      "shipping_calculator_success_one_rate": "C'è una solo modalità di spedizione disponibile per",
      "shipping_calculator_success_no_rate": "Scusa ma non ci sono modalità di spedizione per questa destinazione",
      "shipping_calculator_success_at": "a",
      "shipping_calculator_success_many_rates": {
        "there_are": "Ci sono",
        "shipping_rates_available_for": "modalità di spedizione disponibile per",
        "starting_at": ", a partire da"
      },
      "note": "Istruzioni speciali per il venditore"
    },
    "label": {
      "product": "Prodotto",
      "price": "Prezzo",
      "quantity": "Quantità",
      "total": "Totale",
      "or": "oppure"
    },
    "ajax_cart": {
      "continue_shopping": "Contina lo Shopping",
      "go_to_cart": "Vai al Carrello",
      "success_text": "è stato aggiunto al carrello",
      "error": "Errore",
      "loading": "Caricando",
      "close": "Chiudi"
    }
  },
  "collections": {
    "general": {
      "title": "Collezioni",
      "no_matches": "Spiacenti, non ci sono prodotti in questa collezione",
      "link_title": "Guarda la nostra {{ title }} collezione",
      "grid_view": "Griglia",
      "list_view": "Lista",
      "shop_the_collection": "Guarda la Collezione",
      "show_more": "Mostra altro",
      "no_more_product": "Non ci sono altri prodotti",
      "items_count": {
        "one": "prodotto",
        "other": "prodotti"
      },
      "items_with_count": {
        "one": "{{ count }} prodotto",
        "other": "{{ count }} prodotti"
      }
    },
    "sidebar": {
      "types": "Tipo di Prodotto",
      "vendors": "Marchio",
      "tags": "Tags",
      "clear": "Rimuovi",
      "clear_all": "Rimuovi tutti",
      "refined_by": "Filtra per"
    },
    "sorting": {
      "title": "Disponi per",
      "featured": "In primo piano",
      "best_selling": "Più venduti",
      "az": "Alfabeticamente, A-Z",
      "za": "Alfabeticamente, Z-A",
      "price_ascending": "Prezzo, dal più basso al più alto",
      "price_descending": "Prezzo, dal più alto al più basso",
      "date_descending": "Data, dai nuovi ai meno recenti",
      "date_ascending": "Data, Dai meno recenti ai nuovi"
    },
    "toolbar": {
      "view_as": "Vista",
      "show": "Mostra",
      "showing": "da",
      "all": "Tutti",
      "of": "di",
      "previous": "<<",
      "next": ">>"
    }
  },
  "contact": {
    "form": {
      "name": "Nome",
      "email": "Email",
      "phone": "Telefono",
      "message": "Commento",
      "placeholder_message": "Si prega di lasciare il commento qui",
      "send": "Invia",
      "post_success": "Grazie per averci contattato. Ti risponderemo appena possibile.",
      "submit_contact": "Invia Contatto"
    }
  },
  "customer": {
    "account": {
      "title": "Mio Account",
      "details": "Dettagli Account",
      "view_addresses": "Vedi Indirizzo",
      "return": "Ritorna ai dettagli dell'Account"
    },
    "activate_account": {
      "title": "Attiva Account",
      "subtext": "Crea una Password per il tuo Account",
      "password": "Password",
      "password_confirm": "Conferma Password",
      "submit": "Attiva Account",
      "cancel": "Rifiuta Invito"
    },
    "addresses": {
      "title": "Il tuo Indirizzo",
      "default": "Predefinito",
      "add_new": "Aggiungi un nuovo indirizzo",
      "edit_address": "Modifica Indirizzo",
      "first_name": "Nome",
      "last_name": "Cognome",
      "company": "Società",
      "address1": "Indirizzo1",
      "address2": "Indirizzo2",
      "city": "Città",
      "country": "Nazione",
      "province": "Provincia",
      "zip": "Codice Avviamento Postale",
      "phone": "Telefono",
      "set_default": "Imposta come indirizzo predefinito",
      "add": "Aggiungi Indirizzo",
      "update": "Aggiorna Indirizzo",
      "cancel": "Cancella",
      "edit": "Modifica",
      "delete": "Elimina",
      "delete_message": "Sei sicuro di voler eliminare questo indirizzo?"
    },
    "login": {
      "title": "Login Cliente",
      "email": "Indirizzo Email",
      "password": "Password",
      "forgot_password": "Hai dimenticato la tua password?",
      "sign_in": "Registrati",
      "login": "Entra",
      "cancel": "Ritorna allo Store",
      "guest_title": "Continua come ospite",
      "guest_continue": "Continua"
    },
    "orders": {
      "title": "Storico ordini",
      "order_number": "Ordine",
      "date": "Data",
      "payment_status": "Stato del pagamento",
      "total": "Totale",
      "none": "Non hai ancora effettuato ordini",
      "fulfillment_status": "Stato dell'ordine"
    },
    "order": {
      "title": "Ordine {{ name }}",
      "date": "Fatto il {{ date }}",
      "cancelled": "Ordine cancellato il {{ date }}",
      "cancelled_reason": "Motivo: {{ reason }}",
      "billing_address": "Indirizzo di Fatturazione",
      "payment_status": "Stato del Pagamento",
      "shipping_address": "Indirizzo di Spedizione",
      "fulfillment_status": "Stato dell'ordine",
      "discount": "Sconto",
      "shipping": "Costi di Spedizione",
      "tax": "Tasse",
      "product": "Prodotto",
      "sku": "SKU",
      "price": "Prezzo",
      "quantity": "Quantità",
      "total": "Totale",
      "fulfilled_at": "Effettuato il {{ date }}",
      "subtotal": "Subtotale"
    },
    "recover_password": {
      "title": "Reimposta la tua password",
      "email": "Email",
      "submit": "Invia",
      "cancel": "Cancella",
      "subtext": "Ti invieremo una Email per reimpostare la password",
      "success": "Ti abbiamo inviato una Email con il link per reimpostare la tua password"
    },
    "reset_password": {
      "title": "Reimposta la password del tuo Account",
      "subtext": "Inserisci una nuova password per {{ email }}",
      "password": "Password",
      "password_confirm": "Conferma Password",
      "submit": "Reimposta Password"
    },
    "register": {
      "title": "Crea Account",
      "first_name": "Nome",
      "last_name": "Cognome",
      "email": "Email",
      "password": "Password",
      "submit": "Crea un Account",
      "cancel": "Ritorna allo Store"
    },
    "form": {
      "error_message": "Spiacenti, qualcosa è andato storto. Per piacere inserisci informazioni corrette e invia di nuovo:"
    }
  },
  "home_page": {
    "sections": {
      "frontpage_title": "Collezione Prima Pagina",
      "featured_title": "Collezioni in primo piano",
      "news_title": "Le ultime novità"
    },
    "onboarding": {
      "modal_title": "Ci siamo quasi...",
      "no_products_html": "Non hai articoli nella Collezione Prima Pagina. Questo avviso apparirà fino a quando <a href=\"\/admin\/collections?tutorial=Frontpage\"> aggiungi un prodotto a questa collezione<\/a>.",
      "add_product": "Aggiungi un prodotto",
      "product_title": "Esempio di Titolo del Prodtto",
      "no_collections_html": "Non hai nessuna collezione da vedere qui.",
      "add_collection": "Aggiungi una Collezione",
      "collection_title": "Esempio di Titolo della Collezione"
    },
    "show_more": "Mostra altro",
    "no_more_product": "Non ci sono altri prodotti"
  },
  "layout": {
    "cart": {
      "title": "Carrello",
      "items_count": {
        "one": "Oggetto",
        "other": "Oggetti"
      }
    },
    "customer": {
      "account": "Account",
      "logged_in_as_html": "Benvenuto, {{ first_name }}",
      "log_out": "Esci",
      "log_in": "Entra",
      "create_account": "Crea un Account"
    },
    "footer": {
      "linklist_title": "Link Veloci",
      "social_title": "Rimani Connesso",
      "newsletter_title": "Newsletter",
      "accepted_payments": "Sistemi di pagamento accettati"
    }
  },
  "products": {
    "general": {
      "previous_product_html": "&larr; Prodotto precedente",
      "next_product_html": "Prossimo Prodotto &rarr;",
      "from": "Da"
    },
    "product": {
      "sale": "Disponibile",
      "sold_out": "Esaurito",
      "on_sale_from_html": "<strong>In vendita<\/strong> da {{ price }}",
      "unavailable": "Non Disponibile",
      "compare_at": "Confronta con",
      "quantity": "Quantità",
      "add_to_cart": "Aggiungi al Carrello",
      "select_options": "Seleziona un'opzione",
      "quick_view": "Quick View",
      "in_stock": "Disponibile",
      "out_of_stock": "Non Disponibile",
      "many_in_stock": "Più di 1 a magazzino",
      "from": "da"
    }
  },
  "date_formats": {
    "month_day_year": " %d\/%B\/%Y"
  },
  "wishlist": {
    "general": {
      "my_wishlist": "La miia lista dei desideri",
      "product_image": "Immagine del Prodotto",
      "product_name": "Nome del Prodotto",
      "unit_price": "Prezzo unitario",
      "share_wishlist": "Condividi la tua lista dei desideri",
      "no_login_html": "Per creare una lista dei desideri devi <a href=\"\/account\/login\">Accedere<\/a> oppure <a href=\"\/account\/register\">creare un Account<\/a>.",
      "add_to_wishlist": "Aggiungi alla lista dei desideri",
      "added_to_wishlist": "Aggiunto alla lista dei desideri",
      "note": "Già presente nella tua lista dei desideri",
      "subtext": "Per creare una lista dei desideri devi",
      "sign_in": "Accedere",
      "or": "oppure",
      "create_account": "Creare un Account"
    },
    "ajax_wishlist": {
      "go_to_wishlist": "Vai alla lista dei desideri",
      "success_text": "è stato aggiunto alla tua lista dei desideri"
    }
  },
  "gift_cards": {
    "issued": {
      "expired": "Scaduto il {{ expiry }}",
      "active": "Scadrà il {{ expiry }}",
      "redeem": "Usa questo codice alla cassa per riscattare la tua carta regalo",
      "shop_link": "Inizia lo shopping",
      "print": "Stampa",
      "disabled": "Disabilitato",
      "title": "Ecco la tua carta regalo da {{ value }}  per {{ shop }}!",
      "subtext": "Ecco la tua carta regalo!"
    }
  }
}